import { createUseStyles } from 'react-jss'
import { color, textSize } from 'styles/helpers'

export default createUseStyles(theme => ({
  description: {
    ...textSize(14, 18),
    ...color('textSecondary', theme.theme)
  },
  lastChildWithTitle: {
    marginTop: -11,
  },
  separatingWithTitle: {
    marginTop: -11,
    marginBottom: 16,
  }
}))
